import { useIntl } from '@/intl'
import { useAnalytics } from '@/scopes/common/infrastructure/analytics/hooks'
import { createSustainabilityDataLayerEvent } from '@/scopes/products/pages/components/Legacy/PracticalInformation/helpers/CreateDataLayerEvent'
import { Accordion } from '@sunwebgroup/ui-components'

export interface SustainabilityCertificateInfoProps {
  title: string
}

export function SustainabilityCertificateInfo({ title }: SustainabilityCertificateInfoProps) {
  const { sendEvent } = useAnalytics()
  const intl = useIntl()

  const content = intl.formatMessage({ id: 'accommodation_page_sustainability_certificate_content' })

  const handleChange = (isOpen: boolean) => {
    sendEvent(createSustainabilityDataLayerEvent({ isOpen }))
  }

  return (
    <Accordion.Item title={title} icon="IconSustainable" onOpenChange={handleChange}>
      <div dangerouslySetInnerHTML={{ __html: content }} />
    </Accordion.Item>
  )
}
